import {ActiveUserService, CEProtocol, CEConstructor, ListSpecType} from 'lionheartland';
import {HttpClient} from 'lionheartland';
import {EOViewGrantService} from '../../core/view-grant/eo-view-grant';
import {SOGetViewGrant} from '../../core/view-grant/so-get-view-grant';
import {RAPutViewGrant} from './ra-put-view-grant';
import {RAPostViewGrant} from './ra-post-view-grant';
import {RADeleteViewGrant} from './ra-delete-view-grant';
import {AbstractEntityCore} from 'lionheartland';
import {EntityCoreProtocol} from 'lionheartland';
import { CEViewGrant } from "./ce-view-grant"


export class ViewGrantCoreBase extends AbstractEntityCore implements EntityCoreProtocol {

  type = 'viewGrant';
  title = 'View grant';
  ceProtocol: CEConstructor = CEViewGrant

  entityService: EOViewGrantService;
  soGetClass = SOGetViewGrant;
  soGet: SOGetViewGrant;


  constructor(
    public activeUserService: ActiveUserService,
  ) {
    super(
      activeUserService,
      EOViewGrantService,
      null,
    );
    this.adapters = [
      new RAPostViewGrant(this),
      new RAPutViewGrant(this),
      new RADeleteViewGrant(this),
    ];
    this.resetSoGet()
    this.setDefaultAdapters();
    this.finalInit();
  }

  resetSoGet() {
    this.soGet = new SOGetViewGrant();
    this.soGet.queryOptions.limit = this.limit;
  }


}